import { createBrowserRouter, RouterProvider } from "react-router-dom";
import HomePage, { loader as homeLoader } from "./pages/Home";
import ProductsPage, { loader as productsLoader } from "./pages/Products";
import DealsPage, { loader as dealsLoader } from "./pages/Deals";
import RootLayout from "./pages/Root";
import Agreement from "./pages/Agreement";
import StatusPage from "./pages/Status";
import ServerPage, { loader as serverLoader } from "./pages/Server";
import { ConfigProvider } from "antd";
import { useEffect } from "react";
import { preactStorage } from "./storage/preact";

const router = createBrowserRouter([
  {
    index: true,
    element: <HomePage />,
    errorElement: <h1>Error</h1>,
    loader: homeLoader,
  },
  {
    path: "/:server",
    element: <RootLayout />,
    // loader: productsLoader,
    children: [
      {
        index: true,
        element: <ServerPage />,
        loader: serverLoader,
      },
      {
        path: "products",
        element: <ProductsPage />,
        loader: productsLoader,
      },
      {
        path: "deals",
        element: <DealsPage />,
        loader: dealsLoader,
      },
      {
        path: "agreement",
        element: <Agreement />,
      },
    ],
  },

  {
    path: "/success",
    element: <StatusPage type="success" />,
  },
  {
    path: "/fail",
    element: <StatusPage type="fail" />,
  },
]);

function App() {
  useEffect(() => {
    preactStorage.init();
  }, []);

  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "#4b40ff",
        },
      }}
    >
      <RouterProvider router={router} />
    </ConfigProvider>
  );
}

export default App;
